import React from 'react';

import {
  ProgressWrapper,
  ProgressContainer,
  ProgressPercentage,
  ProgressBar,
} from './SurveyProgress.styles';

interface Question {
  visible: boolean;
  getType: () => string;
  isEmpty: () => boolean;
}

interface Page {
  visible: boolean;
  questions: Question[];
}

interface SurveyProgressProps {
  pages: Page[];
}

interface Progress {
  total: number;
  answered: number;
}

const getProgress = (pages: Page[]): Progress => pages.reduce(
  (res, page) => {
    if (!page.visible) return res;

    const questionProgress = page.questions.reduce(
      (questionRes, question) => {
        if (!question.visible) return questionRes;
        const questionType = question.getType();
        if (questionType === 'html') return questionRes;

        return {
          total: questionRes.total + 1,
          answered: question.isEmpty() ? questionRes.answered : questionRes.answered + 1,
        };
      },
      res,
    );

    return questionProgress;
  },
  { total: 0, answered: 0 },
);

const SurveyProgress: React.FC<SurveyProgressProps> = ({ pages }) => {
  const progress = getProgress(pages);

  const percentage = React.useMemo(
    () => (progress.total === 0 ? 100 : Math.floor((progress.answered / progress.total) * 100)),
    [progress],
  );

  const barNow = progress.total === 0 ? 100 : progress.answered;
  const barMax = progress.total === 0 ? 100 : progress.total;

  return (
    <ProgressWrapper>
      <ProgressContainer>
        <ProgressBar now={barNow} min={0} max={barMax} />
      </ProgressContainer>
      <ProgressPercentage>{`${percentage}%`}</ProgressPercentage>
    </ProgressWrapper>
  );
};

export default SurveyProgress;
